/**
 * DH Signature Animations — GSAP + ScrollTrigger
 * 5 signature moments + enhanced scroll reveals
 */
(function () {
  'use strict';

  // Bail if user prefers reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Wait for GSAP to load (deferred scripts)
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Shared defaults
    gsap.defaults({ ease: 'power3.out', duration: 1 });

    // 1. HERO — handled by dh-hero.liquid's own script (parallax + caption reveal)

    // ================================================================
    // 2. EDITORIAL COLLECTION — Left/right offset slide-in
    // ================================================================
    var editorialLeft = document.querySelector('.dh-editorial__left');
    var editorialRight = document.querySelector('.dh-editorial__right');
    var editorialBgNum = document.querySelector('.dh-editorial__bg-num');

    if (editorialLeft && editorialRight) {
      var editorialTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.dh-editorial',
          start: 'top 75%',
          end: 'bottom 20%',
          toggleActions: 'play none none none'
        }
      });

      if (editorialBgNum) {
        editorialTL.fromTo(editorialBgNum,
          { scale: 0.5, opacity: 0 },
          { scale: 1, opacity: 0.04, duration: 1.2, ease: 'power2.out' },
          0
        );
      }

      editorialTL.fromTo(editorialLeft,
        { x: -60, opacity: 0 },
        { x: 0, opacity: 1, duration: 1 },
        0.1
      );

      editorialTL.fromTo(editorialRight,
        { x: 60, opacity: 0 },
        { x: 0, opacity: 1, duration: 1 },
        0.25
      );

      // Stagger the value props inside editorial
      var editorialEyebrow = editorialLeft.querySelector('.dh-editorial__eyebrow');
      var editorialTitle = editorialLeft.querySelector('.dh-editorial__title');
      var editorialDesc = editorialLeft.querySelector('.dh-editorial__desc');
      var editorialCTA = editorialLeft.querySelector('.dh-editorial__cta');

      if (editorialEyebrow) {
        editorialTL.fromTo(editorialEyebrow,
          { y: 20, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.6 },
          0.2
        );
      }
      if (editorialTitle) {
        editorialTL.fromTo(editorialTitle,
          { y: 30, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.8 },
          0.35
        );
      }
      if (editorialDesc) {
        editorialTL.fromTo(editorialDesc,
          { y: 20, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.7 },
          0.55
        );
      }
      if (editorialCTA) {
        editorialTL.fromTo(editorialCTA,
          { y: 15, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.6 },
          0.7
        );
      }
    }

    // ================================================================
    // 3. CLUB LOUNGE CARD — 3D flip reveal on scroll
    // ================================================================
    var clCard = document.querySelector('.cl-promo__card');
    var clTextCol = document.querySelector('.cl-promo__text-col');

    if (clCard) {
      var clTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.cl-promo',
          start: 'top 70%',
          toggleActions: 'play none none none'
        }
      });

      // Card flips in from the side
      clTL.fromTo(clCard,
        {
          rotateY: -90,
          opacity: 0,
          transformPerspective: 1000,
          transformOrigin: 'left center'
        },
        {
          rotateY: 0,
          opacity: 1,
          duration: 1.2,
          ease: 'power3.out'
        },
        0
      );

      // Caption slides up after card lands
      var clCaption = document.querySelector('.cl-promo__card-caption');
      if (clCaption) {
        clTL.fromTo(clCaption,
          { y: 20, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.5 },
          0.8
        );
      }

      // Text column slides in from right
      if (clTextCol) {
        clTL.fromTo(clTextCol,
          { x: 40, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.9 },
          0.3
        );

        // Stagger the stats
        var stats = clTextCol.querySelectorAll('.cl-promo__stat');
        if (stats.length) {
          clTL.fromTo(stats,
            { y: 30, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.6, stagger: 0.15 },
            0.6
          );
        }

        // CTA button
        var clCTA = clTextCol.querySelector('.cl-promo__cta');
        if (clCTA) {
          clTL.fromTo(clCTA,
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.5 },
            0.9
          );
        }
      }
    }

    // ================================================================
    // 4. STATS COUNT-UP — Animated numbers
    // ================================================================
    var statVals = document.querySelectorAll('.dh-stat__number, .cl-promo__stat-val');

    statVals.forEach(function (el) {
      var text = el.textContent.trim();
      // Extract number and suffix (e.g., "40+" -> 40, "+")
      var match = text.match(/^([^0-9]*)(\d+)(.*)$/);
      if (!match) return;

      var prefix = match[1];
      var num = parseInt(match[2], 10);
      var suffix = match[3];
      var obj = { val: 0 };

      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.to(obj, {
            val: num,
            duration: 1.8,
            ease: 'power2.out',
            onUpdate: function () {
              el.textContent = prefix + Math.round(obj.val) + suffix;
            }
          });
        }
      });
    });

    // ================================================================
    // 5. TESTIMONIALS — Staggered card cascade
    // ================================================================
    var testimonialCards = document.querySelectorAll('.dh-boarding-grid .dh-boarding-pass');

    if (testimonialCards.length) {
      gsap.fromTo(testimonialCards,
        {
          y: 50,
          opacity: 0,
          rotateX: 5,
          transformPerspective: 800
        },
        {
          y: 0,
          opacity: 1,
          rotateX: 0,
          duration: 0.8,
          stagger: 0.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: '.dh-boarding-grid',
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );
    }

    // ================================================================
    // ENHANCED SCROLL REVEALS — Replace basic dh-reveal with GSAP
    // ================================================================
    var reveals = document.querySelectorAll('.dh-reveal:not(.dh-visible)');

    reveals.forEach(function (el) {
      // Skip elements already handled by signature animations
      if (el.closest('.dh-editorial') ||
          el.closest('.cl-promo') ||
          el.closest('.dh-boarding-grid')) return;

      gsap.fromTo(el,
        { y: 40, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none none'
          }
        }
      );
    });

    // ================================================================
    // TRUST BAR — Quick stagger after page load
    // ================================================================
    var trustItems = document.querySelectorAll('.dh-trust__item');
    if (trustItems.length) {
      gsap.fromTo(trustItems,
        { y: 15, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.out',
          delay: 0.6
        }
      );
    }

    // ================================================================
    // WHY DIFFERENT — Card grid stagger
    // ================================================================
    var whyCards = document.querySelectorAll('.dh-why-diff__card');
    if (whyCards.length) {
      gsap.fromTo(whyCards,
        { y: 40, opacity: 0, scale: 0.95 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.dh-why-diff',
            start: 'top 70%',
            toggleActions: 'play none none none'
          }
        }
      );
    }

    // ================================================================
    // PRO BANNER — Text reveal
    // ================================================================
    var proBanner = document.querySelector('.dh-pro-banner__inner');
    if (proBanner) {
      var proEls = proBanner.children;
      gsap.fromTo(proEls,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.7,
          stagger: 0.12,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.dh-pro-banner',
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );
    }

    // ================================================================
    // BOTTOM CTA — Final punch
    // ================================================================
    var ctaSection = document.querySelector('.dh-cta');
    if (ctaSection) {
      var ctaEls = ctaSection.children;
      gsap.fromTo(ctaEls,
        { y: 25, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.7,
          stagger: 0.15,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: ctaSection,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    }
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
